import { makeStyles } from '@material-ui/styles';
import { REMINDER_STYLES } from './reminderConstants';

const colorsFor = (reminderStyle) =>
  REMINDER_STYLES.find((item) => item.value === reminderStyle) ?? {};

export const useReminderFormStyles = makeStyles((theme) => ({
  description: {
    color: 'black',
  },
  fieldLabel: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },
  styleCardsWrapper: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  messageFieldWrapper: {
    position: 'relative',
  },
  messageInput: {
    paddingBottom: theme.spacing(3),
  },
  counter: {
    position: 'absolute',
    bottom: theme.spacing(1.25),
    right: theme.spacing(1.5),
    color: '#757575',
    pointerEvents: 'none',
  },
}));

/**
 * Styles for a single style card, colored from REMINDER_STYLES by the
 * `reminderStyle` passed in. The radio follows the border color while the label
 * follows the text color - on WARN those deliberately differ.
 */
export const useStyleCardStyles = makeStyles((theme) => ({
  card: {
    flex: 1,
    margin: 0,
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    border: '1px solid',
    borderRadius: '6px',
    padding: theme.spacing(2),
    cursor: 'pointer',
    backgroundColor: ({ reminderStyle }) =>
      colorsFor(reminderStyle).backgroundColor,
    borderColor: ({ reminderStyle }) => colorsFor(reminderStyle).borderColor,
  },
  radio: {
    flexShrink: 0,
    marginTop: theme.spacing(-1),
    marginLeft: theme.spacing(-1),
    color: ({ reminderStyle }) => colorsFor(reminderStyle).borderColor,
    '&.Mui-checked': {
      color: ({ reminderStyle }) => colorsFor(reminderStyle).borderColor,
    },
  },
  label: {
    fontWeight: 600,
    color: ({ reminderStyle }) => colorsFor(reminderStyle).color,
  },
  description: {
    color: ({ reminderStyle }) => colorsFor(reminderStyle).color,
  },
}));
